// extracted by mini-css-extract-plugin
export default {"homeContainer":"homeV2_homeContainer__v4Idg","heading2":"homeV2_heading2__XS-OF","nbnbImg":"homeV2_nbnbImg__x9ZTy","campusImg":"homeV2_campusImg__QrHB+"};